module.exports = __webpack_public_path__ + "img/thumbsup.217b342a.svg";